module.exports = __webpack_public_path__ + "officialStatic/img/s9.c46a222.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/wireless/s9.png
// module id = qixT
// module chunks = 0